import * as React from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";

import { cn } from "@/lib/utils";

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
    pointerBottom?: boolean;
    pointerLeft?: boolean;
    pointerRight?: boolean;
  }
>(
  (
    {
      className,
      align = "center",
      pointerBottom = false,
      pointerLeft = false,
      pointerRight = false,
      sideOffset = 4,
      ...props
    },
    ref
  ) => (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={cn(
          "z-50 w-72 rounded-[13px] border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
          className,
          pointerBottom &&
            " after:content-[''] after:absolute after:bottom-[-6px] after:left-1/2 after:-ml-[6px] after:w-3 after:h-3 after:bg-white after:rotate-45 after:rounded-[2.5px] after:border-r after:border-b after:border-border",
          pointerLeft &&
            " after:content-[''] after:absolute after:top-[10px] after:left-0 after:-ml-[5px] after:w-3 after:h-3 after:bg-white after:rotate-[135deg] after:rounded-[2.5px] after:border-r after:border-b after:border-border",
          pointerRight &&
            " after:content-[''] after:absolute after:top-[10px] after:right-0 after:-mr-[5px] after:w-3 after:h-3 after:bg-white after:rotate-[-45deg] after:rounded-[2.5px] after:border-r after:border-b after:border-border"
        )}
        {...props}
      />
    </PopoverPrimitive.Portal>
  )
);
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverTrigger, PopoverContent };
